import React, { Component } from "react";
import { Grid, Button, Label, Input } from "semantic-ui-react";
import moment from "moment";
import "../accounting.css";
import TMTable from "./tmtable";
class TNMReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tnms: [],
      date: moment().format("DD/MM/YYYY")
    };
  }
  gentmreport(date) {
    this.props.genreport(date).then(tmstuffs => {
      this.setState({ tnms: this.state.tnms.concat(tmstuffs) });
    });
  }
  render() {
    const today = moment().format("DD/MM/YYYY");
    return (
      <div className="TNMReport">
        <Grid>
          <Grid.Row centered>
            <Grid.Column width={6}>
              <Label>Select date to run report</Label>
              <Input
                type="date"
                name="enddate"
                onChange={e => this.setState({ date: e.target.value })}
                defaultValue={today}
                fluid
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Button
                color="blue"
                onClick={() => {
                  this.handle;
                }}
              >
                Create Report
              </Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={10}>
              <TMTable tnms={this.state.tnms} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default TNMReport;



// WEBPACK FOOTER //
// ./src/components/accounting/tnm/tnmreport.jsx